import { MenuOutlined, UserOutlined } from "@ant-design/icons";
import { Layout, Menu, Popover } from "antd";
import SubMenu from "antd/lib/menu/SubMenu";
import React, { Suspense } from "react";
import { connect } from "react-redux";
import { I18n } from "react-redux-i18n";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";

import { AuthActions } from "app/redux/actions";
import { AuthSelectors } from "app/redux/reducers";
import AdvancedAvatar from "components/shared/AdvancedAvatar/AdvancedAvatar";
import PageSkeleton from "components/shared/PageSkeleton/PageSkeleton";

const { Header, Sider, Content } = Layout;

class PersistentLayout extends React.PureComponent {
  state = {
    collapsed: true,
    openKeys: [],
    visible: false,
  };

  hidePopover = () => {
    this.setState({ visible: false });
  };

  handleVisibleChange = visible => {
    this.setState({ visible });
  };

  handleLogout = () => {
    const { logout } = this.props;
    logout(() => this.props.navigate(I18n.t("routes.login.url")));
  };

  handleUserDetail = () => {
    const { me } = this.props;
    this.props.navigate(`/userCPFL/${me.id}`);
  };

  toggleNav = () => {
    this.setState(state => {
      return { ...state, collapsed: !state.collapsed };
    });
  };

  /**
   * Controla a abertura dos submenus do menu lateral.
   * Garante que apenas um submenu esteja aberto por vez.
   *
   * @param {string[]} openKeys - Array de chaves dos submenus atualmente abertos.
   */
  handleSubMenuOpenChange = openKeys => {
    if (openKeys.length > 0) {
      // Mantém apenas o último submenu aberto
      const latestOpenKey = openKeys[openKeys.length - 1];
      this.setState({
        openKeys: [latestOpenKey],
      });
    } else {
      // Permite fechar todos os submenus
      this.setState({
        openKeys: [],
      });
    }
  };

  render() {
    const { me, location } = this.props;
    const { collapsed, openKeys, visible } = this.state;

    const isAuthenticated = true;

    const menu = (
      <div className="user-dropdown">
        <p className="user-dropdown__label">{me?.email}</p>
        <p className="user-dropdown__installation-number">{me?.name}</p>
        <hr />
        <div className="user-dropdown__group-button">
          <button
            onClick={this.handleUserDetail}
            className="user-dropdown__group-button__button"
          >
            Minha conta
          </button>
        </div>
        <div className="user-dropdown__group-button">
          <button
            onClick={this.handleLogout}
            className="user-dropdown__group-button__button"
          >
            Sair
          </button>
        </div>
      </div>
    );

    return isAuthenticated ? (
      <Layout className="home">
        <Sider
          width={248}
          className="sider"
          breakpoint={window.screen.width > 640 ? "md" : null}
          collapsedWidth={0}
          collapsible
          onBreakpoint={broken => {
            this.setState({ ...this.state, collapsed: broken });
          }}
          collapsed={collapsed}
        >
          <button
            className="transparent-btn sider__cpfl-logo"
            onClick={() => {
              if (me?.profileType === 6) {
                this.props.navigate(I18n.t("routes.userCPFL.url"));
              } else {
                this.props.navigate(I18n.t("routes.partner.url"));
              }
            }}
          >
            <img alt="" src="/assets/svg/cpfl-logo.svg" />
          </button>
          <img
            alt=""
            src="/assets/svg/sider-overlay.svg"
            className="sider__overlay"
          />
          <div className="sider__header">
            <p className="sider__header__name">CPFL Total</p>
            <p className="sider__header__email">{me?.email}</p>
          </div>

          {(window.location.hostname.includes("-stg") ||
            window.location.hostname.includes("localhost")) && (
            <div>
              <p className="sider__tag">Ambiente de Teste</p>
            </div>
          )}

          <Menu
            className="sider sider__menu"
            mode="inline"
            theme="dark"
            selectedKeys={[location.pathname]}
            openKeys={openKeys}
            onOpenChange={this.handleSubMenuOpenChange}
          >
            {me?.profileType !== 6 ? (
              <>
                <Menu.Item key="/distributor">
                  <Link
                    className="menu_link"
                    to="distributor"
                    style={{ color: "white !important" }}
                  >
                    Distribuidoras
                  </Link>
                </Menu.Item>
                <Menu.Item key="/partner">
                  <Link
                    className="menu_link"
                    to="partner"
                    style={{ color: "white !important" }}
                  >
                    Financeiras
                  </Link>
                </Menu.Item>
                <SubMenu key="/user" title="Administradores">
                  <Menu.Item key="/userCPFL">
                    <Link className="menu_link" to="userCPFL">
                      CPFL
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="/userPartner">
                    <Link className="menu_link" to="userPartner">
                      Financeiras
                    </Link>
                  </Menu.Item>
                </SubMenu>
                <SubMenu key="/clientes" title="Clientes">
                  <Menu.Item key="/client">
                    <Link className="menu_link" to="client">
                      Clientes
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="/hash-agency">
                    <Link className="menu_link" to="hash-agency">
                      Agência Virtual
                    </Link>
                  </Menu.Item>
                </SubMenu>
                <SubMenu key="/contracts" title="Contratos">
                  <Menu.Item key="/contract">
                    <Link className="menu_link" to="contract">
                      Todos
                    </Link>
                  </Menu.Item>
                </SubMenu>
                <SubMenu key="/simulations" title="Simulações">
                  <Menu.Item key="/pre-contract">
                    <Link className="menu_link" to="pre-contract">
                      Todas
                    </Link>
                  </Menu.Item>
                </SubMenu>
                <SubMenu
                  key="/consolidate"
                  title="Consolidados"
                  theme="dark"
                  style={{ backgroundColor: "#0097d2" }}
                >
                  <Menu.Item key="/consolidated/dashboard">
                    <Link className="menu_link" to="consolidated/dashboard">
                      Dashboard
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="/consolidated/pre-contract">
                    <Link className="menu_link" to="consolidated/pre-contract">
                      Simulações
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="/consolidated/simulation-approves-per-client">
                    <Link
                      className="menu_link"
                      to="consolidated/simulation-approves-per-client"
                    >
                      Simulações por cliente
                    </Link>
                  </Menu.Item>

                  <Menu.Item key="/consolidated/access-virtual-agency">
                    <Link
                      className="menu_link"
                      to="consolidated/access-virtual-agency"
                    >
                      Agência virtual
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="/consolidated/access-rede-facil-code">
                    <Link
                      className="menu_link"
                      to="consolidated/access-rede-facil-code"
                    >
                      Rede Fácil
                    </Link>
                  </Menu.Item>

                  <Menu.Item key="/consolidated/contract">
                    <Link className="menu_link" to="consolidated/contract">
                      Contratos
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="/consolidated/errors">
                    <Link className="menu_link" to="consolidated/errors">
                      Erros
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="/consolidated/clients">
                    <Link className="menu_link" to="consolidated/clients">
                      Clientes
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="/consolidated/client-logins">
                    <Link className="menu_link" to="consolidated/client-logins">
                      Logins
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="/consolidated/access">
                    <Link className="menu_link" to="consolidated/access">
                      Acessos
                    </Link>
                  </Menu.Item>
                </SubMenu>
                <SubMenu key="/installments" title="Parcelas">
                  <Menu.Item key="/installment">
                    <Link className="menu_link" to="installment">
                      Todas
                    </Link>
                  </Menu.Item>
                </SubMenu>
                {me?.profileType == 1 ? (
                  <>
                    <Menu.Item key="/logs">
                      <Link className="menu_link" to="logs">
                        Logs
                      </Link>
                    </Menu.Item>
                    <Menu.Item key="/joblogs">
                      <Link className="menu_link" to="joblogs">
                        Jobs Logs
                      </Link>
                    </Menu.Item>
                    <SubMenu key="/block-list/user" title="Block List">
                      <Menu.Item key="/block-list/users">
                        <Link className="menu_link" to="block-list/users">
                          Usuários
                        </Link>
                      </Menu.Item>
                      <Menu.Item key="/block-list/cities">
                        <Link className="menu_link" to="block-list/cities">
                          Cidades
                        </Link>
                      </Menu.Item>
                    </SubMenu>
                  </>
                ) : (
                  <SubMenu key="/block-list/user" title="Block List">
                    <Menu.Item key="/block-list/users">
                      <Link className="menu_link" to="block-list/users">
                        Usuários
                      </Link>
                    </Menu.Item>
                    <Menu.Item key="/block-list/cities">
                      <Link className="menu_link" to="block-list/cities">
                        Cidades
                      </Link>
                    </Menu.Item>
                  </SubMenu>
                )}
              </>
            ) : (
              <SubMenu key="/user" title="Administradores">
                <Menu.Item key="/userCPFL">
                  <Link className="menu_link" to="userCPFL">
                    CPFL
                  </Link>
                </Menu.Item>
                <Menu.Item key="/userPartner">
                  <Link className="menu_link" to="userPartner">
                    Financeiras
                  </Link>
                </Menu.Item>
              </SubMenu>
            )}
            <Menu.Item key="/report-downloads">
              <Link className="menu_link" to="report-downloads">
                Central de Downloads
              </Link>
            </Menu.Item>
          </Menu>
        </Sider>
        <Layout>
          <Header className="white-header">
            <button
              className="transparent-btn white-header__toggle"
              onClick={this.toggleNav}
            >
              <MenuOutlined style={{ color: "black" }} />
            </button>
            <div className="white-header__menu">
              <Popover
                placement="bottomRight"
                content={menu}
                trigger="click"
                open={visible}
                onOpenChange={this.handleVisibleChange}
              >
                <div className="white-header__menu__avatar">
                  <AdvancedAvatar>
                    <UserOutlined />
                  </AdvancedAvatar>
                  <img
                    className="white-header__menu__avatar__caret"
                    alt=""
                    src="/assets/svg/caret.svg"
                  />
                </div>
              </Popover>
            </div>
          </Header>
          <Content className="main-content">
            <Suspense fallback={<PageSkeleton />}>
              <Outlet />
            </Suspense>
          </Content>
        </Layout>
      </Layout>
    ) : null;
  }
}

const mapStateToProps = state => ({
  me: AuthSelectors.getMe(state),
});

const mapDispatchToProps = dispatch => ({
  logout: callback => dispatch(AuthActions.logout(callback)),
});

const PersistentLayoutWithRouter = props => {
  const navigate = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
    const applyMenuStyles = () => {
      const style = document.createElement("style");
      style.textContent = `
        .ant-layout-sider .ant-menu .ant-menu-item,
        .ant-layout-sider .ant-menu .ant-menu-submenu-title,
        .ant-layout-sider .ant-menu .ant-menu-item a,
        .ant-layout-sider .ant-menu .ant-menu-submenu-title a {
          color: #ffffff !important;
        }
        .ant-layout-sider .ant-menu {
          background-color: #0097d2;
        }
        .ant-layout-sider {
          background-color: #0097d2;
        }
      `;
      document.head.appendChild(style);
    };

    applyMenuStyles();
  }, []);

  return (
    <PersistentLayout {...props} navigate={navigate} location={location} />
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PersistentLayoutWithRouter);
